module.exports = __webpack_public_path__ + "media/components/src/assets/images/dot/dot_01-d76cf5b58d9f752d5a28467b1fa4b1c0.svg";